import { useState, useEffect } from "react";

const BP_IDENTS = [
   "mobileSm",
   "mobileLg",
   "tabletSm",
   "tabletLg",
   "desktopSm",
   "desktopLg",
];

const BP_DIMENSIONS = [
   0,
   481,
   601,
   769,
   1025,
   1281,
];

const _getBreakpoint = () => {
   // I think I can make this a little bit more efficient

   // mobileSm: >= 0, < 481
   // mobileLg: >= 481, < 601
   // tabletSm: >= 601, < 769
   // tabletLg: >= 769, < 1025
   // desktopSm: >= 1025, < 1281
   // desktopLg: >= 1281
   let bpIndex = BP_IDENTS.length - 1;

   if (typeof window !== "undefined") {
      for (; bpIndex > 0; bpIndex--) {
         const innerWidth = window.innerWidth;

         if (innerWidth >= BP_DIMENSIONS[bpIndex])
            return bpIndex;
      }
   }

   return bpIndex;
}

const useBreakpoint = (inputBreakpoints: object | Array<any>, inherit: boolean) => {
   // initialize breakpoint
   const [currBreakpoint, setCurrBreakpoint] = useState(_getBreakpoint());

   // handle resize event
   useEffect(() => {
      const _handleWindowResize = () => {
         setCurrBreakpoint(prevBreakpoint => {
            if (prevBreakpoint !== _getBreakpoint())
               return _getBreakpoint();
            return prevBreakpoint;
         });
      };

      window.addEventListener('resize', _handleWindowResize);

      // clean up
      return () => window.removeEventListener('resize', _handleWindowResize);
   }, []);

   // array of 3 or 6 
   // ie. [16, 32, 64] or [0, 8, 16, 32, 64, 128]
   if (Array.isArray(inputBreakpoints)) {
      // case 2
      if (inputBreakpoints.length === 3)
         return inputBreakpoints[(currBreakpoint - currBreakpoint % 2) / 2];

      // case 3
      else if (inputBreakpoints.length === 6)
         return inputBreakpoints[currBreakpoint];
   }

   else {
      // initialize
      const output = [];
      for (let i = 0; i < 6; i++)
         output.push({});

      // compare input to breakpoints
      let prevBp = {};

      for (let i = 0; i < BP_IDENTS.length; i++) {
         const currBp = inputBreakpoints[BP_IDENTS[i]];

         if (currBp === undefined)
            output[i] = prevBp;

         else {
            if (inherit && typeof currBp === 'object') {
               output[i] = { ...prevBp, ...currBp };
               prevBp = { ...output[i] };
            }

            else {
               output[i] = currBp;
               prevBp = currBp;
            }
         }
      }

      return output[currBreakpoint];
   }
}

// 30 November
// Reconsiderations
// - some kind of JSON structure?
// - reusable components 
// - what to do if there's smaller breakpoints that are null

// 2 December
// Observations
// - while switching between breakpoints, it takes a moment to load the new layout

// 19 December
// - 

export { useBreakpoint };